import React from "react"
import memoize from "lodash/memoize"
import ButtonCell from "../components/ButtonCell"

const modalRoot = document.getElementById(`modal-root`)

export default function withModalSetup(WrappedModal) {
  return class extends React.Component {
    state = {
      isModalMounted: false,
    }

    el = document.createElement(`div`)

    buttonConfToButtonReactNodes = memoize(buttonConf =>
      buttonConf
        .filter(cfg => !cfg.hidden)
        .map(buttonPropsObj => (
          <ButtonCell key={buttonPropsObj.text} {...buttonPropsObj} />
        )),
    )

    componentDidMount() {
      modalRoot.appendChild(this.el)
      // eslint-disable-next-line
      this.setState({ isModalMounted: true })
      // TODO incorrect work
      // document.addEventListener(`keydown`, this.handleKeydown, false)
    }

    componentWillUnmount() {
      modalRoot.removeChild(this.el)
      // TODO incorrect work
      // document.removeEventListener(`keydown`, this.handleKeydown, false)
    }

    handleKeydown = event => {
      const { onOk, onCancel } = this.props

      switch (event.keyCode) {
        case 13:
          event.stopPropagation()
          onOk()
          break
        case 27:
          event.stopPropagation()
          onCancel()
          break
        default:
      }
    }

    render() {
      const { buttonConf } = this.props
      const { isModalMounted } = this.state
      const buttonReactNodes = this.buttonConfToButtonReactNodes(buttonConf)

      return (
        <WrappedModal
          isModalMounted={isModalMounted}
          containerDomNode={this.el}
          buttonReactNodes={buttonReactNodes}
          {...this.props}
        />
      )
    }
  }
}
